import t from "./types";
import { Api } from '../../services/httpService';
import { dispatch } from "react-hot-toast";

export const getMerchants = () => async (dispatch) => {
    const res = await Api('get', `/merchant`);
    if (res)
        await dispatch({ type: t.FETCHED_ACTIVITY, payload: res });
}

export const getRemittanceData = (params) => async (dispatch) => {
    // const res = await Api('get', `/payments/${merchantId}/${buyerPlatformId}`)
    const res = await Api('post', `/payments/findAsParam`, params)
    //console.log("getRemittanceData-Action",res);
    if (res) {
        await dispatch({ type: t.GET_REMITTANCE, payload: res });
    }
}

export const getDashboardData = (merchantId, buyerPlatformId) => async (dispatch) => {
    // console.log("merchantId, buyerPlatformId", merchantId, buyerPlatformId);
    const res = await Api('get', `/dashboard/${merchantId}/${buyerPlatformId}`);
    if (res) {
        await dispatch({ type: t.FETCHED_DASHBOARD_ACTIVITY, payload: res });
    }
}

export const createRequest = (params) => async (dispatch) => {
    try {
        const res = await Api('post', '/traditionalrequests/entry', params)
        if (res.success) {
            await dispatch({ type: t.REDIRECT_REQUEST , payload:true })
        }    
        await dispatch({ type: t.CREATE_REQUEST, payload: res });
    } catch (error) {
        console.log('error',error);
    }
    
}
export const reSetRedirectFromRequest = () => async dispatch => {
    await dispatch({ type: t.REDIRECT_REQUEST , payload:false })
}
export const getRemittanceDataByMonth = (merchantId, buyerPlatformId) => async (dispatch) => {
    const res = await Api('get', `/payments/${merchantId}/${buyerPlatformId}`)

    //console.log("getRemittanceData-Action",res);

    if (res) {
        await dispatch({ type: t.GET_REMITTANCE_BY_MONTH, payload: res });
    }
}

export const getNotifications = (merchantId) => async (dispatch) => {
    const res = await Api('get', `/notifications/${merchantId}`)

    if (res) {
        await dispatch({ type: t.GET_NOTIFICATIONS, payload: res })
    }
}

export const getNotificationPagination = (param) => async (dispatch) => {

    const res = await Api('post', '/notifications/findAsParamMsg', param)

    if (res) {
        await dispatch({ type: t.GET_NOTIFICATIONS_PAGINATION, payload: res })
    }
}


export const updateNotifications = (params) => async (dispatch) => {
    const res = await Api('post', `/notifications/markRead`, params)
    if (res) {
        await dispatch({ type: t.UPDATE_NOTIFICATIONS, payload: res })
    }
}

export const verifyEmail = (params) => async (dispatch) => {
    const res = await Api('post', `/users/verifyEmail`, params, true)
    if (res) {
        await dispatch({ type: t.VERIFY_EMAIL, payload: res })
    }
}

export const verifyOtp = (params) => async (dispatch) => {
    const res = await Api('post', `/users/verifyOTP`, params, true)
    if (res) {
        await dispatch({ type: t.VERIFY_OTP, payload: res })
    }
}

export const changPassword = (params) => async (dispatch) => {
    const res = await Api('post', `/users/changePswd`, params, true)
    if (res) {
        await dispatch({ type: t.CHANGE_PSWD, payload: res })
    }
}

export const getCmsPage = (id) => async (dispatch) => {
    dispatch({ type: t.FETCHED_CMS_PAGE_LOADING, payload: true });
    const res = await Api("get", `/staticValues/${id}`);
    if (res.success) {
        await dispatch({ type: t.FETCHED_CMS_PAGE_SINGLE, payload: res.body });
    } else {
        await dispatch({ type: t.FETCHED_CMS_PAGE_ERROR, payload: res });
    };
    dispatch({ type: t.FETCHED_CMS_PAGE_LOADING, payload: false });
};

export const getCmsPages = () => async (dispatch) => {
    dispatch({ type: t.FETCHED_CMS_PAGE_LOADING, payload: true });
    const res = await Api("get", `/staticValues`);
    if (res.success) {
        await dispatch({ type: t.FETCHED_CMS_PAGE, payload: res.body });
    } else {
        await dispatch({ type: t.FETCHED_CMS_PAGE_ERROR, payload: res });
    };
    dispatch({ type: t.FETCHED_CMS_PAGE_LOADING, payload: false });
};

export const addOrUpdateSubMerchant = (param) => async (dispatch) => {
    const res = await Api("post", '/merchant/submerchant/addorupdate', param);
    if (res) {
        await dispatch({ type: t.ADD_UPDATE_SUB_MERCHANT, payload: res })
    } else {
        console.log("Error in add update submerchant");
    }
}

export const getSubMerchant = (param) => async (dispatch) => {
    const res = await Api("POST", `/merchant/submerchant`, param);
    if (res) {
        await dispatch({ type: t.GET_SUB_MERCHANT, payload: res })
    } else {
        console.log("Error in add update submerchant");
    }
}

// Get document for merchant 

export const getDocumentLibrary = (param) => async (dispatch) => {
    const res = await Api("POST", `/common/accountDocument/findAsParam`, param);
    if (res.success) {
        dispatch({ type: t.GET_DOCUMENT_LIBRARY, payload: res })
    } else {
        console.log("Error in getting merchant document");
    }
}

export const DocView = (docPath) => async (dispatch) => {
    const res = await Api('get', `/common/docView?filePath=${docPath}`);
    if (res.success) {
        await dispatch({ type: t.FETCHED_DOCUMENT_MONITORING_FILE, payload: res.body });
    }
}


// login with otp 
export const loginWithOtp = (param) => async (dispatch) => {
    try {
        const res = await Api('POST', '/users/loginByOtp', param, true);
        dispatch({ type: t.LOGIN_WITH_OTP, payload: res });
    } catch (error) {
        console.log("error", error);
    }
}

// Verify login otp

export const verifyLoginOtp = (param) => async (dispatch) => {
    try {
        const res = await Api("POST", '/users/verifyOTP', param, true);
        dispatch({ type: t.VERIFY_LOGIN_OTP, payload: res });
    } catch (error) {
        console.log("Error", error);
    }
}

// Merchant analytics 

export const getAccountOverviewReport = (param) => async (dispatch) => {
    try {
        const res = await Api("GET", `/common/accountOverview?merchantid=${param.merchantId}&buyerplatformid=${param.buyerPlatformId}`);
        dispatch({ type: t.GET_ACCOUNT_OVERVIEW_REPORT, payload: res });
    } catch (error) {
        console.log("Error", error);
    }
}

export const getHistoricalOverviewReport = (param) => async (dispatch) => {
    try {
        const res = await Api("GET", `/common/historicalOverview?merchantid=${param.merchantId}&buyerplatformid=${param.buyerPlatformId}`);
        dispatch({ type: t.GET_HISTORICAL_OVERVIEW_REPORT, payload: res });
    } catch (error) {
        console.log("Error", error);
    }
}



{/** Admin check  */ }

export const getGenericsStoreProcedure = (param) => async (dispatch) => {
    try {
        let res;
        if(param?.buyerPlatformId){
             res = await Api("get", `/common/getGenericSPData/${param.storeProcedureName}?merchant_id=${param.merchantId}&Buyer_platform=${param.buyerPlatformId}`);
             dispatch({ type: t.GET_STORE_PROCEDURE, payload: res })
            }
        else{
            res = await Api("get", `/common/getGenericSPData/${param.storeProcedureName}?merchant_id=${param.merchantId}`);
            dispatch({ type: t.GET_STORE_PROCEDURE_NOTIFICATION_COUNT, payload: res })
        }
    } catch (error) {
        console.log("Error", error);
    }
}

/* get merchant user List */

export const getMerchantUserList = (merchantId) => async (dispatch) => {
    try {
        const res = await Api("GET", `/merchant/getSubMerchantUser/${merchantId}`);
        dispatch({ type: t.GET_MERCHANT_USER_LIST, payload: res });
    } catch (error) {
        console.log("Error", error);
    }
}


